module.exports = __webpack_public_path__ + "static/media/dark-theme-selected-mode-icon.51d23e65.svg";